export default [
    {
        path: '/',
        name: 'Home',
        component: (resolve) => require(['./Home.vue'], resolve),
        meta:{
            slidebar: false
        }

    },
    {
        path: '/home/index',
        name: 'index page',
        meta:{
            slidebar: true
        },
        component:(r) => require(['./Index.vue'], r)
    },
    {
        path: "/home/CustomerAnalysis",
        name: "CustomerAnalysis",
        meta: {
            slidebar:true
        },
        component:(r) => require(["./CustomerAnalysis.vue"], r)
    }
]



// WEBPACK FOOTER //
// ./src/modules/home/router.js